<template>
  <div class="w-100">
    <SearchRoomWithMultiImageBanner
      v-if="getMerchant().booking_engine_header_type == 'MULTI_IMAGE_BANNER'"
      :promo-code-popup="popup_data" />
    <template v-else>
      <Mobile v-if="is_mobile" :reload="apply_pc"></Mobile>
      <Desktop
        v-else
        :reload="apply_pc"
        :promo-code-popup="popup_data"></Desktop>
    </template>

    <!-- promo code popup -->
    <b-modal
      size="lg"
      hide-header
      hide-footer
      body-class="p-0"
      centered
      v-model="show_popup">
      <div
        class="w-100 bg-white rounded-4 box-shadow-light-aff overflow-hidden position-relative promocode-popup"
        v-if="show_popup"
        :key="popup_key">
        <img
          src="../../../assets/img/icon/cancel.png"
          class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
          width="33"
          style="z-index: 1051; right: 0"
          @click="closePopup()" />
        <flickity ref="flickity" class="text-center" :options="flickityOptions">
          <div class="carousel-cell w-100" v-for="data_image in popup_data">
            <div
              class="w-100 blur-image-bg position-relative"
              :class="
                $isEmpty(data_image.popup_description) ? 'img-full' : 'img-half'
              ">
              <img :src="data_image.popup_image" class="img" />
              <div
                class="bg"
                :style="{
                  backgroundImage: `url('${data_image.popup_image}')`,
                }"></div>
              <button
                v-if="$isEmpty(data_image.popup_description)"
                @click="applyPromoCode(data_image)"
                class="button-primary px-4 btn-apply-overlay">
                APPLY PROMO
              </button>
            </div>

            <div
              v-if="!$isEmpty(data_image.popup_description)"
              class="w-100 text-center p-4 overflow-y-auto"
              style="height: 20vh">
              <p class="mb-3 body-1-3">{{ data_image.popup_description }}</p>
              <button
                @click="applyPromoCode(data_image)"
                class="button-primary px-4">
                APPLY PROMO
              </button>
            </div>
          </div>
        </flickity>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Desktop from '@/pages/hotel/be/RoomDesktop';
import Mobile from '@/pages/hotel/be/RoomMobile';
import SearchRoomWithMultiImageBanner from './SearchRoomWithMultiImageBanner.vue';
import { mapGetters, mapMutations } from 'vuex';
import { get } from '@/services/index.js';
import moment from 'moment';
import Flickity from 'vue-flickity';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';

export default {
  components: {
    Desktop,
    Mobile,
    Flickity,
    PopUpBackground,
    SearchRoomWithMultiImageBanner,
  },
  data() {
    return {
      is_mobile: true,
      show_popup: false,
      popup_key: 0,
      popup_data: [],
      apply_pc: false,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        adaptiveHeight: false,
        draggable: true,
        wrapAround: true,
        autoPlay: 6000,
        pauseAutoPlayOnHover: false,
      },
    };
  },
  computed: {
    mobile_firs_load() {
      return this.getBeFirstLoad();
    },
  },
  watch: {
    mobile_firs_load() {
      if (!this.mobile_firs_load) {
        this.getPromoCodeAvlb();
      }
    },
  },
  mounted() {
    this.setActiveHotelModule(null);
    this.$postLog('SEARCH', '', 'First Load');
    if (this.$route.query.agent_id) {
      this.setAgentId(this.$route.query.agent_id);
      this.$router.replace({ query: {} });
    }
    if (
      !this.is_mobile ||
      (this.is_mobile && !this.mobile_firs_load) ||
      this.getMerchant().booking_engine_header_type == 'MULTI_IMAGE_BANNER'
    ) {
      this.getPromoCodeAvlb();
    }
  },
  created() {
    if (window.innerWidth > 767) {
      this.is_mobile = false;
    }
  },
  methods: {
    ...mapGetters(['getMerchant', 'getBeFilter', 'getBeFirstLoad']),
    ...mapMutations(['setBeFilter', 'setAgentId', 'setActiveHotelModule']),
    getPromoCodeAvlb() {
      get('CORE_HOTEL', 'promocode-option', {
        merchant_id: this.getMerchant().id,
        check_in_date: moment(this.getBeFilter().date.check_in).format(
          'YYYY-MM-DD'
        ),
        check_out_date: moment(this.getBeFilter().date.check_out).format(
          'YYYY-MM-DD'
        ),
      }).then((response) => {
        let res = response.data;
        if (res.success) {
          this.popup_data = res.data;
          if (res.data.length == 1) {
            this.flickityOptions.pageDots = false;
            this.flickityOptions.prevNextButtons = false;
          }
          if (res.data.length == 1) {
            this.flickityOptions.draggable = false;
            this.flickityOptions.prevNextButtons = false;
          }
          if (res.data.length > 0) {
            this.show_popup = true;
            setTimeout(() => {
              this.popup_key++;
            }, 300);
          }
        }
      });
    },
    applyPromoCode(data) {
      let params = {
        date: {
          check_in: this.getBeFilter().date.check_in,
          check_out: this.getBeFilter().date.check_out,
        },
        guest: {
          adult: this.getBeFilter().guest.adult,
          child: 0,
          infant: 0,
        },
        promo_code: data.promo_code,
      };
      this.setBeFilter(params);
      this.closePopup();
      this.apply_pc = true;
    },
    closePopup() {
      this.show_popup = false;
    },
  },
};
</script>
<style scoped>
.h-90vh {
  height: 90vh;
}
.ovrflw-y-auto {
  overflow-y: auto;
}
.promocode-popup {
  height: 85vh;
}
.promocode-popup .img-full {
  height: 85vh;
}
.promocode-popup .img-half {
  height: 65vh;
}
.promocode-popup .btn-apply-overlay {
  display: table;
  position: absolute;
  bottom: 32px;
  left: 0px;
  right: 0px;
  z-index: 1046 !important;
  width: 170px;
  margin-inline: auto;
}
@media screen and (max-width: 768px) {
  .promocode-popup {
    height: 65vh;
  }
  .promocode-popup p {
    font-size: 14px !important;
  }
  .promocode-popup .img-full {
    height: 65vh;
  }
  .promocode-popup .img-half {
    height: 45vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/Room.vue